import { Component, input, output } from '@angular/core';

import { Observable } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput } from '@camelot/form-model';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationCore } from '../../../translation.service';

@Component({
  selector: 'cam-filters-form',
  templateUrl: './filters-form.component.html',
  styleUrls: ['./filters-form.component.scss'],
  imports: [ButtonComponent, TranslatePipe, FormComponent],
})
export class FiltersFormComponent extends CamBaseComponent {
  form = input<CamAbstractInput[]>([]);

  askValidation$ = input<Observable<null>>();

  filtersSelected = output<any>();

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public apply(data: any) {
    this.filtersSelected.emit(data);
  }

  public clear() {
    this.filtersSelected.emit(null);
  }
}
